export default "__VITE_ASSET__Tk8pCfv7__"